import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeftBig24, IcoClose24 } from '@onefootprint/icons';
import { IconButton, useConfirmationDialog } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { LEGACY_IDV_CONTAINER_ID, TOUCH_TARGET_CLASS } from '@/idv2/components/constants';
import { useNavigationHeaderPortalId } from '@/idv2/components/internal/gallery-portal-context';
import { useDynamicTitle } from './hooks/use-dynamic-title';
export type NavigationHeaderProps = {
  canGoBack: boolean;
  onBack: () => void;
  onClose?: () => void;
  containerId?: string;
  hideButtons?: boolean;
};
export const NavigationHeader = t0 => {
  const $ = _c(30);
  const {
    canGoBack,
    onBack,
    onClose,
    containerId: t1,
    hideButtons: t2
  } = t0;
  const containerId = t1 === undefined ? LEGACY_IDV_CONTAINER_ID : t1;
  const hideButtons = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      keyPrefix: "confirmationDialog"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t3);
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      keyPrefix: "shell.global.components.navigation-header"
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    t: tHeader
  } = useTranslation("idv2", t4);
  const headerRef = useRef(null);
  const [portalTarget, setPortalTarget] = useState(null);
  let t5;
  if ($[2] !== containerId) {
    t5 = {
      containerId,
      headerRef
    };
    $[2] = containerId;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const dynamicTitle = useDynamicTitle(t5);
  const confirmationDialog = useConfirmationDialog();
  const hasContent = dynamicTitle || !hideButtons;
  const portalId = useNavigationHeaderPortalId();
  let t6;
  let t7;
  if ($[4] !== portalId) {
    t6 = () => {
      setPortalTarget(document.getElementById(portalId));
    };
    t7 = [portalId];
    $[4] = portalId;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  useLayoutEffect(t6, t7);
  let t8;
  if ($[7] !== confirmationDialog || $[8] !== onClose || $[9] !== t) {
    t8 = () => {
      confirmationDialog.open({
        title: t(_temp),
        description: t(_temp2),
        primaryButton: {
          label: t(_temp3),
          onClick: onClose
        },
        secondaryButton: {
          label: t(_temp4)
        }
      });
    };
    $[7] = confirmationDialog;
    $[8] = onClose;
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleClose = t8;
  if (!portalTarget) {
    return null;
  }
  const t9 = dynamicTitle || !hideButtons || undefined;
  const t10 = !hasContent;
  let t11;
  if ($[11] !== hasContent || $[12] !== t10) {
    t11 = cx("navigation-header flex items-center justify-center relative z-1", {
      "h-12 py-3 min-[900px]:h-14 min-[900px]:py-4": hasContent,
      "py-2": t10
    });
    $[11] = hasContent;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== canGoBack || $[15] !== handleClose || $[16] !== hideButtons || $[17] !== onBack || $[18] !== tHeader) {
    t12 = !hideButtons && <div className="absolute left-0">{canGoBack ? <IconButton className={TOUCH_TARGET_CLASS} onClick={onBack} aria-label={tHeader(_temp5)} icon={IcoChevronLeftBig24} /> : <IconButton className={TOUCH_TARGET_CLASS} onClick={handleClose} aria-label={tHeader(_temp6)} icon={IcoClose24} />}</div>;
    $[14] = canGoBack;
    $[15] = handleClose;
    $[16] = hideButtons;
    $[17] = onBack;
    $[18] = tHeader;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== dynamicTitle) {
    t13 = dynamicTitle && <span className="text-label-2 text-primary text-center whitespace-nowrap overflow-hidden text-ellipsis max-w-[calc(100%-80px)]">{dynamicTitle}</span>;
    $[20] = dynamicTitle;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t13 || $[25] !== t9) {
    t14 = <div ref={headerRef} data-has-content={t9} className={t11}>{t12}{t13}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t9;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== portalTarget || $[28] !== t14) {
    t15 = createPortal(t14, portalTarget);
    $[27] = portalTarget;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}
function _temp3($_1) {
  return $_1.confirm;
}
function _temp4($_2) {
  return $_2.cancel;
}
function _temp5($_3) {
  return $_3["back-button"]["aria-label"];
}
function _temp6($_4) {
  return $_4["close-button"]["aria-label"];
}